<nb-card class="nb_card_pop_up full_pop_up meal_item mobilePopup">
  <nb-card-header>
    <div class="title">
      <span>{{TitleLabel}}</span>
    </div>
    <div class="actions">
      <button type="button" nbButton ghost (click)="Back()" tabindex="-1">
        <nb-icon icon="close-outline" style="z-index: 1000;"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body [formGroup]="ExerciseItemForm">

    <!-- <input style="visibility:hidden" formControlName="ID" />
    <input style="visibility:hidden" formControlName="IsPublic" /> -->

    <div class="row">

      <div class="col-12">

        <div class="form-group row">
          <div class="col-sm-4 label col-form-label required-label"><span i18n="@@ExerciseName">Exercise Name</span> *
          </div>
          <div class="col-sm-8">
            <input nbInput formControlName="Name" [readonly]="!IsForEdit"
              [status]="(Name?.errors?.required || Name?.hasError('minlength') || Name?.hasError('maxlength')) ? 'danger' : 'primary'"
              type="text" fullWidth shape="semi-round" i18n-placeholder="@@RequiredField"
              placeholder="{{ExerciseNameLabel}} (required)">
            <ngx-validation-message i18n-label="@@ExerciseName" label="Exercise Name"
              [showRequired]="Name?.errors?.required && Name.touched" [showPattern]="Name?.hasError('pattern')" min=1
              max=200></ngx-validation-message>
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-4 label col-form-label required-label"><span i18n="@@VideoUrl">Video Url</span><br /><span
              style="font-size:smaller; font-weight:normal; color:#000;">(ie: YouTube Link should not be share link)</span></div>
          <div class="col-sm-8">
            <input (blur)="onYoutubeUrlBlur()" nbInput formControlName="YoutubeUrl" [readonly]="!IsForEdit"
              [status]="(YoutubeUrl?.errors?.required || YoutubeUrl?.hasError('minlength') || YoutubeUrl?.hasError('maxlength')) ? 'danger' : 'primary'"
              type="text" fullWidth shape="semi-round" i18n-placeholder="@@RequiredField" i18n-placeholder="@@VideoUrl"
              placeholder="Video Url">
            <ngx-validation-message i18n-label="@@VideoUrl" label="Video Url"
              [showRequired]="YoutubeUrl?.errors?.required && YoutubeUrl.touched"
              [showPattern]="YoutubeUrl?.hasError('pattern')" min=1 max=200></ngx-validation-message>
          </div>
        </div>

        <!-- ImageName -->
        <!--<div class="form-group row">
          <div class="col-sm-4 label col-form-label required-label"><span i18n="@@ImageName">Image Name</span> *</div>
          <div class="col-sm-8">
            <input nbInput formControlName="ImageName" [readonly]="!IsForEdit" [status]="(ImageName?.errors?.required || ImageName?.hasError('minlength') || ImageName?.hasError('maxlength')) ? 'danger' : 'primary'" type="text" fullWidth shape="semi-round"
              i18n-placeholder="@@RequiredField" i18n-placeholder="@@ImageName" placeholder="Image Name">
            <ngx-validation-message i18n-label="@@ImageName" label="Image Name"
                                    [showRequired]="ImageName?.errors?.required && ImageName.touched"
                                    [showPattern]="ImageName?.hasError('pattern')" min=1 max=200></ngx-validation-message>
          </div>
        </div>-->
        <!-- Video -->
        <div class="form-group row">
          <div class="col-sm-4 label col-form-label required-label"><span i18n="@@UploadImage">Video</span>
          </div>
          <div class="col-sm-8">
            <input class="video-input" #videoInput nbInput type="file" [style.display]="(exerciseVideoThumbnailUrl.value)? 'none': 'block'" id="fileExerciseVideo" accept="video/*"
                  name="fileExerciseVideo" (change)="onUploadExerciseVideo($event)" />
            <div class="img-container" *ngIf="exerciseVideoThumbnailUrl.value" (mouseover)="imgHover=true" (mouseleave)="imgHover=false">
              <div class="img-inside">
                <div class="exercise-img-actions" *ngIf="imgHover && IsForEdit">
                  <span onclick="document.getElementById('fileExerciseVideo').click();">
                    <nb-icon class="control-item1" icon="edit-outline"></nb-icon>
                  </span>
                  <span (click)="onResetExerciseVideo(videoInput)">
                    <nb-icon class="control-item2" icon="trash-outline"></nb-icon>
                  </span>
                </div>
                <video class="exercise-img" *ngIf="ExerciseVideoUrl && !exerciseVideoThumbnailUrl.value" [src]="ExerciseVideoUrl.length > 4 ? getVideoUrl(ExerciseVideoUrl):videoExerciseItem"
                  [ngStyle]="{opacity: imgHover==true  ? '0.25' : '1' }" width="100%" height="100%"></video>
                <img class="exercise-img" *ngIf="exerciseVideoThumbnailUrl.value" [src]="exerciseVideoThumbnailUrl.value"
          [ngStyle]="{opacity: imgHover==true  ? '0.25' : '1' }" width="100%" height="100%">
                <input type="hidden" formControlName="ExerciseVideoUrl" />
              </div>
            </div>
            <!-- <ngx-validation-message i18n-label="@@ExerciseImage" label="Exercise Image"
                            [showRequired]="ExerciseImageUrl?.errors?.required"
                            [showPattern]="ExerciseImageUrl?.hasError('pattern')" min=1 max=200></ngx-validation-message> -->
            <div class="clearfix"></div>
          </div>
        </div>
        <!-- image -->
        <div class="form-group row">
          <div class="col-sm-4 label col-form-label required-label"><span i18n="@@UploadImage">Upload Image</span>
          </div>
          <div class="col-sm-8">
            <div class="img-container" (mouseover)="imgHover=true" (mouseleave)="imgHover=false">
              <div class="img-inside">
                <div class="exercise-img-actions" *ngIf="imgHover && IsForEdit">
                  <a href="javascript:void(0)" onclick="document.getElementById('fileExerciseImage').click();">
                    <nb-icon class="control-item1" icon="edit-outline"></nb-icon>
                  </a>
                  <a href="javascript:void(0)" (click)="onResetExerciseImage(imageInput)">
                    <nb-icon class="control-item2" icon="trash-outline"></nb-icon>
                  </a>
                </div>
                <img class="exercise-img" *ngIf="imgExerciseItem" [src]="imgExerciseItem"
                  [ngStyle]="{opacity: imgHover==true  ? '0.25' : '1' }" width="100%" height="100%">
                <input type="file" #imageInput style="display:none;" id="fileExerciseImage" accept="image/*"
                  name="fileExerciseImage" (change)="onUploadExerciseImage($event)" />
                <input type="hidden" formControlName="ExerciseImageUrl" />
              </div>
            </div>
            <!-- <ngx-validation-message i18n-label="@@ExerciseImage" label="Exercise Image"
                                    [showRequired]="ExerciseImageUrl?.errors?.required"
                                    [showPattern]="ExerciseImageUrl?.hasError('pattern')" min=1 max=200></ngx-validation-message> -->
            <div class="clearfix"></div>
          </div>
        </div>

        <!-- VideoName -->
        <!--<div class="form-group row">
          <div class="col-sm-4 label col-form-label required-label"><span i18n="@@VideoName">Video Name</span> *</div>
          <div class="col-sm-8">
            <input nbInput formControlName="VideoName" [readonly]="!IsForEdit" [status]="(VideoName?.errors?.required || VideoName?.hasError('minlength') || VideoName?.hasError('maxlength')) ? 'danger' : 'primary'" type="text" fullWidth shape="semi-round"
              i18n-placeholder="@@RequiredField" i18n-placeholder="@@VideoName" placeholder="Video Name">
            <ngx-validation-message i18n-label="@@VideoName" label="Video Name"
                                    [showRequired]="VideoName?.errors?.required && VideoName.touched"
                                    [showPattern]="VideoName?.hasError('pattern')" min=1 max=200></ngx-validation-message>
          </div>
        </div>-->

        <!-- Video Url -->

      </div>

    </div>

  </nb-card-body>

  <nb-card-footer>
    <div *ngIf="ExerciseItemForm.hasError('urlOrFile')" class="text-danger">
      Only one field can be filled at a time.
    </div>
    <div *ngIf="ExerciseItemForm.hasError('addOne')" class="text-danger">
      There should be either image or video. {{ExerciseItemForm.value.ExerciseVideoUrl}}
    </div>
    <table>
      <tr>
        <td>
          <button i18n="@@Save" nbButton type="submit" *ngIf="IsForEdit" size="small" (click)="SaveExerciseItem()"
            class="btn-circle btn-xl btn-main btn-circle btn-xl" [disabled]="!ExerciseItemForm.valid || isLoading"
            [nbSpinner]="isLoading">Save</button>
        </td>
      </tr>
    </table>
  </nb-card-footer>

</nb-card>
